import { palette, typography } from "../../shared/theme";
export { FTLSelect } from "./FTLSelect";
export { FTLSelectAsync } from "./FTLSelectAsync";
export { FTLSelectCreatable } from "./FTLSelectCreatable";
export { FTLCheckboxSelector } from "../FTLDropdownMenu/FTLCheckboxSelector";
export { InfiniteLoader } from "./InfiniteLoader";
export { CustomValueContainer } from "./CustomValueContainer";
export const defaultSelectStyles = (size = "default", isError, isMulti, isFocused, isDisabled, withCheckboxes) => ({
    container: (provided) => (Object.assign(Object.assign({}, provided), { cursor: "pointer" })),
    indicatorsContainer: (provided) => (Object.assign(Object.assign({}, provided), { display: "flex", justifyContent: "space-between", margin: "0 8px 0 0" })),
    valueContainer: (provided) => (Object.assign(Object.assign(Object.assign(Object.assign({}, provided), { whiteSpace: "nowrap" }), typography.unsupportedSemanticTags.listItemText), { padding: size === "default" ? (isMulti ? "6px 7px" : "9.5px 7px") : "4px 8px" })),
    input: (provided) => (Object.assign(Object.assign({}, provided), { margin: 0, height: 20, display: "flex", alignItems: "center" })),
    control: (provided) => {
        const styles = Object.assign(Object.assign({}, provided), { border: "none", boxShadow: "none", minHeight: size === "default" ? "40px" : "32px", maxHeight: size === "small" ? "32px" : "auto", backgroundColor: palette.textField.disabled, "&:hover": {
                backgroundColor: palette.text.disable,
            } });
        if (isDisabled)
            return styles;
        else {
            return Object.assign(Object.assign({}, styles), { cursor: "pointer", boxShadow: `inset 0 0 0 ${isFocused || isError ? 2 : 1}px ${isError
                    ? palette.border.textFieldError
                    : isFocused
                        ? palette.border.focus
                        : palette.border.textField}`, backgroundColor: isFocused ? "#fff" : palette.textField.inactive, "&:hover": {
                    backgroundColor: isFocused ? "#fff" : palette.text.hover,
                } });
        }
    },
    multiValue: (provided) => (Object.assign(Object.assign({}, provided), { fontSize: "100%", backgroundColor: "#e5e7e8", borderRadius: "4px", margin: 2 })),
    multiValueLabel: (provided) => (Object.assign(Object.assign(Object.assign({}, provided), typography.unsupportedSemanticTags.tooltip), { padding: "2px 4px", paddingLeft: 4, color: palette.text.secondary })),
    multiValueRemove: (provided) => (Object.assign(Object.assign({}, provided), { cursor: "pointer", padding: 2, borderRadius: "0 4px 4px 0" })),
    placeholder: (provided) => (Object.assign(Object.assign(Object.assign({}, provided), typography.unsupportedSemanticTags.listItemText), { margin: 0, color: isDisabled ? palette.text.disable : palette.text.placeholder })),
    menu: (provided) => (Object.assign(Object.assign({}, provided), { zIndex: 1310, overflow: "hidden" })),
    menuList: (provided) => (Object.assign(Object.assign({}, provided), { maxHeight: 128, padding: 0, "& > div > div": {
            color: palette.text.primary,
            padding: withCheckboxes ? 0 : "6px 12px",
        }, "& .MuiFormControlLabel-root": {
            padding: "3.5px 12px",
        } })),
    option: (provided) => (Object.assign(Object.assign(Object.assign({}, provided), typography.unsupportedSemanticTags.listItemText), { backgroundColor: "#fff", color: palette.text.primary, cursor: "pointer", outline: "none", "&:hover": {
            backgroundColor: "#f5f5f6",
        } })),
    dropdownIndicator: (provided) => (Object.assign(Object.assign({}, provided), { marginLeft: 4, padding: 0, "& svg": {
            fill: isDisabled ? palette.text.disable : palette.text.placeholder,
        } })),
    clearIndicator: (provided) => (Object.assign(Object.assign({}, provided), { padding: 0, cursor: "pointer", "& svg": {
            fill: palette.icon.tertiary,
            "&:hover": {
                fill: palette.icon.secondary,
            },
        }, "& button": {
            padding: 0,
            height: size === "small" ? 20 : 24,
            width: size === "small" ? 20 : 24,
        } })),
});
//# sourceMappingURL=index.js.map